/**
 * Grid <NuxtImg> attrs for the property photos modal. Width/sizes vary by
 * col-span; format/quality/densities are shared with getSizes warm.
 */
export const MODAL_GRID_IMAGE_BASE = {
	densities: 'x1',
	format: 'webp',
	quality: 80
} as const;

export const MODAL_GRID_FULL_WIDTH = {
	width: '1280',
	sizes: 'xs:100vw sm:100vw md:100vw lg:80vw xl:80vw 2xl:1100px'
} as const;

export const MODAL_GRID_HALF_WIDTH = {
	width: '800',
	sizes: 'xs:50vw sm:50vw md:50vw lg:45vw xl:45vw 2xl:600px'
} as const;

export function getModalGridGetSizes(width: string, sizes: string) {
	return {
		sizes,
		densities: MODAL_GRID_IMAGE_BASE.densities,
		modifiers: {
			format: MODAL_GRID_IMAGE_BASE.format,
			width,
			quality: String(MODAL_GRID_IMAGE_BASE.quality)
		}
	};
}
